import { Routes } from '@angular/router';
import { PoolsContainerComponent } from './containers/pools-container/pools-container.component';

export const poolsRoutes: Routes = [
    {
        path:       '',
        component:  PoolsContainerComponent
    },
];
